var directive = function(ProductImageSrc) {
  return {
    restrict: 'A',
    scope: {
      productLine: '=',
      width: '@',
      height: '@'
    },
    restrict: 'A',
    link: function(scope, element, attrs) {
      scope.$watch('productLine.cloudinary_image_url', function() {
        element.css('background-image', 'url(' + ProductImageSrc.imgSrc(scope.productLine, attrs.width, attrs.height) + ')')
      })
      element.css('background-image', 'url(' + ProductImageSrc.imgSrc(scope.productLine, attrs.width, attrs.height) + ')')
    }
  };
};
directive.$inject = ['ProductImageSrc'];
tiz.directive('productImageStyle', directive);
